import React from 'react';
import styled from 'styled-components';
import { IconComponentType } from './icon-wrapper.types';

export const IconWrapper: IconComponentType = ({ children, className }) => {
  return <StyledIcon className={className}>{children}</StyledIcon>;
};

const StyledIcon = styled.span`
  --icon-width: 24px;

  width: 1em;
  height: 1em;

  display: flex;
  justify-content: center;
  align-items: center;

  .icon {
    width: 100%;
    height: 100%;
  }
`;
